
import { supabase } from '@/integrations/supabase/client';
import { BookingInfo } from '@/types/booking';

export const createCheckoutSession = async (
  bookingId: string,
  bookingInfo: BookingInfo,
  discount: number = 0,
  couponId: string | null = null
) => {
  try {
    console.log("Creating checkout session with:", {
      bookingId,
      serviceName: bookingInfo.service,
      practitionerName: bookingInfo.practitionerName,
      price: bookingInfo.price,
      currency: bookingInfo.currency,
      discount,
      couponId
    });

    const { data, error } = await supabase.functions.invoke('create-checkout-session', {
      body: {
        // Required parameters for edge function logic
        serviceId: bookingInfo.serviceId,
        practitionerId: bookingInfo.practitionerId,
        bookingId: bookingId,
        
        // Display information parameters (preserved as requested)
        service_name: bookingInfo.service,
        practitioner_name: bookingInfo.practitionerName,
        price: bookingInfo.price,
        currency: bookingInfo.currency,
        
        // Discount parameters (couponCode is a promotion code string if provided)
        discountPercent: discount,
        couponCode: couponId
      }
    });

    if (error) {
      console.error("Checkout session creation error:", error);
      console.error("Error details:", JSON.stringify(error, null, 2));
      throw new Error(error.message || "Failed to create checkout session");
    }

    if (!data) {
      console.error("No data returned from checkout session");
      throw new Error("No data returned from checkout session creation");
    }

    console.log("Checkout session created successfully:", data);
    return data;
  } catch (error: any) {
    console.error("Error in createCheckoutSession:", error);
    throw new Error(error.message || "Failed to create checkout session");
  }
};

export const cleanupFailedBooking = async (bookingId: string) => {
  try {
    console.log("Cleaning up failed booking:", bookingId);
    
    const { error } = await supabase
      .from('bookings')
      .delete()
      .eq('id', bookingId);

    if (error) {
      console.error("Error cleaning up booking:", error);
      throw error;
    }

    console.log("Successfully cleaned up booking:", bookingId);
  } catch (error) {
    console.error("Failed to cleanup booking:", error);
    throw error;
  }
};
